
    window.global = window
  